var EnergyModal = function () {

    component = $('[data-component="energy-modal"]');
    pointDetailTemplate = $('[data-template="point-detail"]').html();
    otherPointsTemplate = $('[data-template="others-points"]').html();
    pointDetailTarget = component.find('.modal-point-container').find('.point-data');
    obj = this;

    function init() {

        addEvents();
    }

    function addEvents() {

        component.on('click', '#OthersPoints', function () {
            var id = $(this).data('point-id');
            obj.getloadOtherPoint(id);
            $('.box-pontos li a').removeClass('active');
            $(this).addClass('active');
        });

        component.on('click', '.equip-list li a', function () {

            var id = $(this).parent().data('id');
            $('.equip-list li a').removeClass('active');
            $(this).addClass("active");
            $('.product-list').hide();
            $('.product-list[data-equip-id="' + id + '"]').show();
            $('.product-list[data-equip-id="' + id + '"] a').first().click();
        });

        component.on('click', '.product-list li a', function () {

            var id = $(this).parent().data('id');
            var equipid = $(this).parent().data('equip-id');

            $('.product-list li a').removeClass('active');
            $(this).addClass("active");

            $('.box-info div').hide();
            $('.box-info div[data-product-id="' + id + '"][data-equip-id="' + equipid + '"]').show();
            $('.box-info div[data-product-id="' + id + '"][data-equip-id="' + equipid + '"]').children().show();
        });

        component.on('click', '.close-modal-energy', function () {

            $(this).trigger('modal:close');
        });
    }

    this.getPointDetail = function (id) {

        $.ajax({
            type: 'GET',
            url: '/umbraco/surface/Widget/GetModal',
            data: { "PointID": id },
            dataType: "json",
            async: true,
            contentType: "application/json; charset=utf-8",
            beforeSend: function () {

                pointDetailTarget.html('');
                loader = $(".loader").clone();
                pointDetailTarget.append(loader);
                loader.show();
            },
            success: function (data) {

                $(".loader").hide();

                data.points = points.points.pontos;
                $('.tit-modal-point').text(data.titulo);

                //Renderiza o template, e adiciona no html
                pointDetailTarget.html(renderPointDetail(data));
                pointDetailTarget.append(renderOthersPoints(data));

                $(".box-img a:first").click();
                $('.box-pontos li a[data-point-id="' + id + '"]').addClass('active');

                //remover os data-product-id repetidos
                /*var seen = {};

                $('.box-info div').each(function() {
                	
                	var txt = $(this).data("product-id");

                	if (seen[txt]) {

                		$(this).remove();
                	}
                	else {

                		seen[txt] = true;
                	}
                });*/

                if ($("#points-modal .box-info-equip .equip-list li").length == 1) {

                	$("#points-modal .box-info-equip").remove();
                }
            }
        });
    }

    this.getloadOtherPoint = function (id) {

        $.ajax({
            type: 'GET',
            url: '/umbraco/surface/Widget/GetModal',
            data: { "PointID": id },
            dataType: "json",
            async: true,
            contentType: "application/json; charset=utf-8",
            beforeSend: function () {

                pointDetailTarget.find('.point-detail').remove();
                pointDetailTarget.find('.loader').remove();
                loader = $(".loader").clone();
                pointDetailTarget.append(loader);
                loader.show();
            },
            success: function (data) {

                $(".loader").hide();

                data.points = points.points.pontos;
                data.points = points.points.pontos;
                $('.tit-modal-point').text(data.titulo);

                //Renderiza o template, e adiciona no html
                pointDetailTarget.prepend(renderPointDetail(data));
                $(".box-img a:first").click();
            }
        });
    }

    function renderPointDetail(pointDetail) {

        return Mustache.render(pointDetailTemplate, pointDetail);
    }

    function renderOthersPoints(pointDetail) {

        return Mustache.render(otherPointsTemplate, pointDetail);
    }

    return init();
}